import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-dropdown/style.css';

import axios from 'axios';
import get from 'lodash/get';
import { NavLink, Switch, Route, Redirect } from 'react-router-dom';

import epicBanner from 'assets/epic-banner.jpg';
import epicBannerFr from 'assets/epic-banner_fr2.png';
// import epicBanner2 from 'assets/new-banner.png';
import PageTitle from 'shared/PageTitle';
import Auth from 'shared/Auth';
import Text from 'ui/Text';
import Button from 'ui/Button';

class CSOShortlist extends Component {
  constructor() {
    super();

    this.state = {};

    this.axiosHandler = axios.CancelToken.source();
  }

  getAreaOfFocus = record => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: 'area_of_focus_fr',
      en: 'area_of_focus',
    };

    const areaOfFocus = get(record, get(backgroundInfo, defaultLang));

    return areaOfFocus;
  };

  getLocation = record => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: 'location_fr',
      en: 'location',
    };

    const location = get(record, get(backgroundInfo, defaultLang));

    return location;
  };

  ge = record => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: 'category_fr',
      en: 'category',
    };

    const category = get(record, get(backgroundInfo, defaultLang));

    return category;
  };

  render() {
    const { shortlistedCSOs } = this.state;

    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const banner = {
      fr: epicBanner,
      en: epicBanner,
    };

    return (
      <div id="shortlisted-csos">
        <PageTitle title="Shortlisted CSOs" />
        <div>
          <div className="inner-content about-awards">
            <div className="hero-img">
              <img src={get(banner, defaultLang)} alt="Epic Banner" />
            </div>
            <div className="flex inner-content justify-content-center auth-buttons  col-sm-12 col-md-12 ">
              <NavLink to="/login" className="btn btn-primary btn-lg sign-up-button" role="button">
                <Text type="tiny-bold" modifiers="uppercase">
                  <FormattedMessage id="Login" defaultMessage="Login" />
                </Text>
              </NavLink>

              <NavLink exact className="btn btn-default1 btn-lg" to="/apply-now">
                <Text type="tiny-bold" modifiers="uppercase">
                  <FormattedMessage id="SignUp" defaultMessage="Sign Up" />
                </Text>
              </NavLink>
            </div>
          </div>
          {/* <div className="inner-content about-explainer shortlisted-csos">
            <Text
              type="heading-semi-bold"
              modifiers="text-center title heavy col-sm-12 col-md-7 center-block">
              <FormattedMessage
                id="CSOShortlist.Discover"
                defaultMessage="The 2019 African CSO Excellence Awards Winners"
              />
            </Text>
            <div className="row no-margin">
              <div className="col-sm-12 col-md-9 col-lg-9 center-block">
                <Text type="explainer" modifiers="explanations-area plain-message text-center">
                  <FormattedMessage
                    id="CSOShortlist.Explanation.First"
                    defaultMessage="
                    Congratulations to the winners of the 2019 African CSO Excellence Awards. This is an impressive list of civil society organisations who thrive through organizational excellence. They have stood out  because of their  openness to being assessed and their commitment to learning and  growth.  These organizations are not only modeling best practices in terms of organizational effectiveness, but also crucially, helping  to start an important conversation in Africa about CSO transparency and accountability.
                    "
                  />
                </Text>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default CSOShortlist;



// WEBPACK FOOTER //
// ./src/components/HomePage/CSOShortlist.js